import { node, object } from "prop-types";
import { useInView } from "react-intersection-observer";
import { CELL_WIDTHS } from "@utils";
import { TimelineScaffoldCell } from "./TimelineScaffoldCell";
import useStyle from "./TimelineCells.style";

export const TimelineVirtualCell = ({ month, children }) => {
  const classes = useStyle();
  const { ref, inView } = useInView({
    scrollMargin: `0px ${5 * CELL_WIDTHS.VALUE.SMALL}px`,
    triggerOnce: false,
  });

  return (
    <div ref={ref} className={classes.segment}>
      {inView ? children : <TimelineScaffoldCell month={month} />}
    </div>
  );
};

TimelineVirtualCell.propTypes = {
  month: object.isRequired,
  children: node.isRequired,
};
